import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

/**
 * Backend validation failures recorded per synced record.
 *
 * Writes made offline are accepted locally and validated server-side once they upload, so a
 * rejection cannot surface at edit time. The backend records it here instead and the row syncs
 * back down, which is what lets a record carry its errors after the fact.
 */
export const sync_errors = sqliteTable('sync_errors', {
  // Selected by the `by_org_extras` sync stream as a plain `id`, not `uuid AS id` as most tables do.
  // Declared here so `select()` returns it at all: without it rows arrive keyless and lists have
  // nothing to key on but their array index.
  id: text('id').notNull().primaryKey(),
  /** The record this error belongs to — a globally unique uuid, matched on without `module`. */
  record_uuid: text('record_uuid'),
  /** Names the table the record lives in (`inventories`, `costs`, `tasks`, ...). Display only. */
  module: text('module'),
  type: text('type'),
  error: text('error'),
  created_at: text('created_at'),
});
